export const benefitTypeConfigurationFields = {
    benefitTypes:'benefitTypes'
};